import * as React from 'react';
const DataPanel = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 18"
		fill="none"
		{...props}
	>
		<path
			fill="#fff"
			d="M2 18c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 0 1 0 16V2C0 1.45.196.98.588.588A1.93 1.93 0 0 1 2 0h14c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v14c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0 1 16 18H2ZM2 5.325h14V2H2v3.325Zm0 5.35h14v-3.35H2v3.35ZM2 16h14v-3.325H2V16ZM3 4.65v-2h2v2H3ZM3 10V8h2v2H3Zm0 5.35v-2h2v2H3Z"
		/>
	</svg>
);
export default DataPanel;
